import React from 'react';
import PropTypes from 'prop-types';

import { Carousel, Toast } from 'antd-mobile';
import RcViewer from '@hanyk/rc-viewer';
import styles from '../detail.module.less';

const propTypes = {
  carouselArray: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
  })).isRequired,
};

class CarouselComponent extends React.Component {
  videoRef = React.createRef()

  constructor(props) {
    super(props);
    this.state = {
      currentSource: 1,
      videoIsPlay: 0,
      carouselHeight: 0,
    };
  }

  componentDidMount() {
    this.setCarouselHeight();
  }

  videoError = () => {
    Toast.show('视频播放失败');
  }

  /**
   * 设置轮播图高度
   */
  setCarouselHeight = () => {
    // const windowWidth = window.screen.width
    // const carouselHeight = windowWidth / 2
    const windowHeight = window.screen.height;
    const carouselHeight = windowHeight / 4;
    this.setState({ carouselHeight });
  }

  slideCarousel = (to) => {
    this.setState({
      currentSource: Number(to + 1),
      videoIsPlay: 0,
    });
    if (this.videoRef.current) this.videoRef.current.pause();
  }

  // 播放视频
  videoPlay = (e) => {
    e.stopPropagation();
    this.videoRef.current.play();
    this.setState({
      videoIsPlay: 1,
    });
  }

  // 视频播放完成
  videoEndPlay = () => {
    this.setState({
      videoIsPlay: 0,
    });
  }

  // 视频暂停
  videoPause = () => {
    this.setState({
      videoIsPlay: 0,
    });
    if (this.videoRef.current) this.videoRef.current.pause();
  }

  render() {
    // 播放暂停按钮
    const { carouselArray } = this.props;
    const { videoIsPlay, carouselHeight, currentSource } = this.state;
    let videoBox;
    switch (videoIsPlay) {
      case 0:
        videoBox = <div className={styles.video_icon_play} onClick={this.videoPlay.bind(this)} role="button" tabIndex={0} label="play" />;
        break;
      case 2:
        videoBox = <div className={styles.video_icon_no} onClick={this.videoPlay.bind(this)} role="button" tabIndex={0} label="noplay" />;
        break;
      default:
        videoBox = null;
    }
    const carouselHtml = carouselArray.map((item) => (
      <div className={styles.carousel_component} style={{ height: `${carouselHeight}px` }} key={item.imgUrl}>
        {item.type === '2' ? (
          <div
            style={{
              position: 'relative',
              height: '100%',
              textAlign: 'center',
              background: '',
            }}
          >
            <video
              className={styles.bannerVideo}
              ref={this.videoRef}
              width="100%"
              poster={item.snapshot}
              webkitplaysinline="true"
              playsInline
              style={{
                height: '100%',
                objectFit: 'fill',
                verticalAlign: 'top',
                width: '100%',
              }}
              src={item.imgUrl}
              onError={this.videoError}
              onPlay={this.videoPlay.bind(this)}
              onPause={this.videoPause.bind(this)}
              onEnded={this.videoEndPlay.bind(this)}
            >
              <track kind="captions" />
            </video>
            {videoBox}
          </div>
        ) : (
          <img
            src={item.imgUrl}
            alt=""
            style={{ width: '100%', height: '100%', verticalAlign: 'top' }}
            onLoad={() => {
              // fire window resize event to change height
              window.dispatchEvent(new Event('resize'));
              // this.setState({ imgHeight: 'auto' });
            }}
          />
        )}
      </div>
    ));
    if (!carouselArray || carouselArray.length === 0) {
      return null;
    }
    return (
      <div className={styles.carousel_box} ref={this.carousel}>
        <RcViewer options={{ title: 0, toolbar: 0 }}>
          <Carousel
            autoplay={false}
            dots={false}
            infinite
            afterChange={(index) => this.slideCarousel(index)}
          >
            {carouselHtml}
          </Carousel>
        </RcViewer>

        <p className={styles.dots}>{`${currentSource}/${carouselArray.length}`}</p>
      </div>
    );
  }
}

CarouselComponent.propTypes = propTypes;

export default CarouselComponent;
